/* eslint-disable @typescript-eslint/no-explicit-any */
import { itemRouteTreeGetFactory } from '~packages/epk-front-shared/lib';
import type { Route } from '~packages/epk-front-shared/lib';

type AggReportRoute = Route<{ addresses?: string[] }>;

const groupsWithoutTo = ['base', 'additional'];
const groupToRemove = (i: any) => {
  if (!groupsWithoutTo.includes(i.id)) return;
  delete i.to;
};

export const itemRouteTreeGet = (
  id: string,
  name: string,
  scopeMap: Record<string, string> = {},
  scopeAddressesMap?: Record<string, string[]>,
  hasTitle?: boolean,
  hasChanges?: boolean,
  queryParams?: any
) => {
  const fn = itemRouteTreeGetFactory<AggReportRoute>(
    id,
    name,
    scopeAddressesMap
      ? i => {
          if (i.id in scopeAddressesMap) {
            i.addresses =
              scopeAddressesMap[i.id as keyof typeof scopeAddressesMap];
          }
          groupToRemove(i);
        }
      : groupToRemove,
    queryParams
  );

  const tree: AggReportRoute[] = [];

  if (hasTitle) {
    tree.push({ id: scopeMap.TITLE, title: 'Титульный лист' });
  }

  tree.push({
    id: 'base',
    title: 'Основное',
    items: [
      { id: scopeMap.INFORMATION_HOUSEHOLD, text: 'Информация о ЛПХ' },
      { id: scopeMap.MEMBERS, text: 'Члены хозяйства' },
      { id: scopeMap.ALL_LANDS, text: 'Земельные участки' },
      { id: scopeMap.ALL_ANIMALS_COUNT, text: 'СХ Животные' },
      { id: scopeMap.ALL_MACHINE_COUNT, text: 'СХ Техника' },
    ],
  });

  const additional = {
    id: 'additional',
    title: 'Дополнительно',
    items: [
      { id: scopeMap.HOME_INFO, text: 'Домовладение' },
      { id: scopeMap.MONEY_PLANTS, text: 'Растениеводство' },
      { id: scopeMap.ALL_ANIMALS_MONEY, text: 'Животноводство' },
      { id: scopeMap.ALL_ECONOMIC, text: 'Экономика' },
      { id: scopeMap.SPOKS, text: 'СПоК' },
    ],
  };

  if (hasChanges) {
    additional.items.push({ id: scopeMap.CHANGES, text: 'Изменения' });
  }

  tree.push(additional);

  fn(tree);

  return tree;
};
